import styles from "./VisitaStepper.module.scss";
import { IconButton, MenuItem, Select, useMediaQuery } from "@mui/material";
import Save from "@mui/icons-material/SaveOutlined";
import ArrowBack from '@mui/icons-material/KeyboardArrowLeftRounded';
import ArrowForward from '@mui/icons-material/KeyboardArrowRightRounded';
import { useState } from "react";

export default function VisitaStepper({
  steps,
  currentIndex,
  onStepChange,
  onSave,
  onNext,
  ultimoPasoIndex,
  onlyView = false,
  esConsultor
}) {

  const [saveLoading, setSaveLoading] = useState(false);

  const handlePrev = () => {
    if (currentIndex > 0) onStepChange(currentIndex - 1);
  };

  const handleNext = async () => {
    if (currentIndex < steps.length - 1) {
      setSaveLoading(true);
      await onNext();
      setSaveLoading(false);
    }
  };

  const handleSave = async () => {
    setSaveLoading(true);
    await onSave();
    setSaveLoading(false);
  };

  const handleSelect = (e) => {
    onStepChange(Number(e.target.value));
  };

  const isReadOnly = steps[currentIndex]?.readOnly;
  const isLastStep = steps.length - 1 === currentIndex;

  return (
    <div className={`${styles.container} ${styles.mobilePosition}`}>
      <div className={styles.controls}>
        <IconButton
          onClick={handlePrev}
          disabled={currentIndex === 0 || saveLoading}
          className={styles.navButton}
        >
          <ArrowBack />
        </IconButton>

        <Select
          value={currentIndex}
          onChange={handleSelect}
          disabled={saveLoading}
          size="small"
          className={styles.select}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 200,
              },
            },
          }}
        >
          {steps.map((s, idx) => (
            <MenuItem key={s.id} value={idx} disabled={idx > ultimoPasoIndex} sx={{ fontSize: 13 }}>
              {s.displayName}
            </MenuItem>
          ))}
        </Select>

        {!onlyView &&
          <IconButton
            color="primary"
            onClick={handleSave}
            disabled={
              (isReadOnly && steps[currentIndex].id !== 5)               // Siempre habilitar guardar en el paso 5 (Datos de la visita)
              || saveLoading
              || (esConsultor && isLastStep)
            }
          >
            <Save />
          </IconButton>}

        <IconButton
          onClick={handleNext}
          disabled={isLastStep || saveLoading}
          className={styles.navButton}
        >
          <ArrowForward />
        </IconButton>
      </div>

      <div className={styles.progressBarWrapper}>
        <div
          className={styles.progressBar}
          style={{
            width: `${((currentIndex + 1) / steps.length) * 100}%`,
          }}
        ></div>
      </div>
    </div>
  );
}